export default function toCPFFormat(rawCPF: string) {
  const cpf = rawCPF?.replace(/[^\d]/g, '');

  if (cpf.length !== 11) {
    return 'CPF inválido';
  }

  return cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}
